/**
 * Empty function implementation, suitable for default values
 */
export const doNothing = () => {
  return;
};
